import { formRequestBody } from '../payUtils';
import type { AbstractSubmitStrategy } from './AbstractSubmitStrategy';
import type { PaymentProcessStrategyHandleProps } from './models';

export class PaymentProcessStrategy implements AbstractSubmitStrategy {
  public handle(props: PaymentProcessStrategyHandleProps): void {
    const {
      payGroupId,
      fields,
      currency,
      amount,
      currencyPrecision,

      card_data,
      trigger,
      signal,
      isNewPayoutAccount,
      requiredFields = [],
      bonusPromotionId,
      withoutBonusPromotion,
    } = props;

    const requiredFieldNames = requiredFields.filter((field) => field.isRequired).map((field) => field.name);

    const requestBody = formRequestBody({
      fields,
      currency,
      amount,
      currencyPrecision,

      card_data,
      isNewPayoutAccount,
      requiredFieldNames,
      bonusPromotionId,
      withoutBonusPromotion,
    });

    trigger({
      payGroupId,
      requestBody,
      signal,
    });
  }
}
